import {
  LitElement,
  TemplateResult,
  property,
  customElement,
  css,
} from "lit-element";
import { html, render } from "lit-html";
import { storeInstance } from "store/index.js";

class KbDownload extends LitElement {
  static get properties() {
    return {
      kbrid: { type: Object },
      src: { type: String },
    };
  }

  constructor() {
    super();
  }

  connectedCallback() {
    this.subscription = storeInstance.subscribe((state) => {
      this.stateChange(state);
    });
    this.state = storeInstance.state;
    this.string = this.state.strings;
    this.src = `/kb/jrest/getResource?kbrid=${this.kbrid}&setToDownload=true#zoom=100`;
    if (this.state.item) {
      this.myRender();
      storeInstance.dispatch("getParentPath", { extId: this.locationExtId });
    }
  }

  disconnectedCallback() {
    storeInstance.unsubscribe(this.subscription);
  }

  stateChange(state) {
    this.state = state;
    this.string = this.state.strings;
    this.myRender();
  }

  myRender() {
    render(this.downloadTemplate(), this.shadowRoot);
  }

  downloadTemplate() {
    return html`
      <style>
        #page {
          display: felx;
          justify-content: center;
          align-content: center;
        }

        #downloadcontainer {
          margin: 3rem;
          padding: 2rem;
          border: 2px solid var(--kb-surface-border-color);
          background-color: var(--kb-surface-color);
          color: var(--kb-on-surface-link-color);
          cursor: pointer;
          text-align: center;
        }

        #downloadcontainer:active {
          color: var(--kb-on-surface-link-color-active);
        }
        #downloadcontainer:visited {
          color: var(--kb-on-surface-link-color-visited);
        }

        iframe {
          margin: 16px auto;
          display: block;
          border: 1px solid #666ccc;
          height: 74vh;
          width: 100%;
        }
      </style>
      <div id="page">
        <!-- <div>
          <iframe src=${this.src} frameborder="1" scrolling="auto" width="850">
          </iframe>
        </div> -->
        <div>
          <iframe src=${this.src} frameborder="1" scrolling="auto" width="1200">
          </iframe>
        </div>
      </div>
    `;
  }
  /*this.state.item.itemLang.dlLblSeqId
window.open('/kb/jrest/getResource?lblSeqId='+ item.resInfo.lblSeqId,'_newtab'+ this.tabnum);
 @click="${this.downloadFile.bind(this)}"
*/
  downloadFile() {
    window.open(
      "/kb/" +
        this.state.langCode +
        "/" +
        this.state.item.item.externalId +
        "/" +
        this.state.item.itemLang.name +
        "_" +
        this.state.item.itemLang.langCode +
        ".pdf",
      "_newtab"
    );
  }
}

customElements.define("kb-download", KbDownload);
